import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Common
      welcome: 'Welcome',
      loading: 'Loading...',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      close: 'Close',
      search: 'Search',
      
      // Navigation
      dashboard: 'Dashboard',
      patients: 'Patients',
      calendar: 'Calendar',
      reports: 'Reports',
      messages: 'Messages',
      administration: 'Administration',
      
      // Dashboard
      todaysTasks: "Today's Tasks",
      recentMessages: 'Recent Messages',
      alerts: 'Alerts',
      quickLinks: 'Quick Links',
      upcomingEncounters: 'Upcoming Encounters',
      
      // Patients
      patientList: 'Patient List',
      patientRecord: 'Patient Record',
      addPatient: 'Add Patient',
      patientDetails: 'Patient Details',
      
      // Messages
      newMessage: 'New Message',
      sendMessage: 'Send Message',
      inbox: 'Inbox',
      
      // Forms
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      phone: 'Phone',
      dateOfBirth: 'Date of Birth',
      medicalRecordNumber: 'Medical Record Number',
      
      // Errors
      required: 'This field is required',
      invalidEmail: 'Invalid email address',
      invalidPhone: 'Invalid phone number',
    },
  },
  es: {
    translation: {
      welcome: 'Bienvenido',
      loading: 'Cargando...',
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      close: 'Cerrar',
      search: 'Buscar',
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;